import React from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./Components/Home/Home";
import ContactUs from "./Components/ContactUs/ContactUs";
import Header from "./includes/Header";
import Footer from "./includes/Footer";
import LivelihoodSkilling from "./Components/OurWork.jsx/LivelihoodSkilling";
import Donate from "./Components/Donate/Donate";
import WomenEmpowerment from "./Components/OurWork.jsx/WomenEmpowerment";
import EnvironmentSustainability from "./Components/OurWork.jsx/EnvironmentSustainability";
import HealthWellbeing from "./Components/OurWork.jsx/HealthWellbeing";
import Volunteer from "./Components/Volunteer";
import AdvisoryBoard from "./Components/About/AdvisoryBoard";
import Governance from "./Components/About/Governance";
import OurNetwork from "./Components/About/OurNetwork";
import Team from "./Components/About/Team";

const App = () => {
  return (
    <>
      <BrowserRouter>
        <Header/>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* ***************************   About Us***************************** */}
          <Route path="/Team" element={<Team/>} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/AdvisoryBoard" element={<AdvisoryBoard />} />
          <Route path="/Governance" element={<Governance />} />{" "}
          <Route path="/Our-Network" element={<OurNetwork />} />{" "}
          <Route path="/Volunteer" element={<Volunteer />} />
          {/* ********************** Our Work **************************** */}
          <Route path="/Livelihood-skilling" element={<LivelihoodSkilling />} />
          <Route path="/Health-Wellbeing" element={<HealthWellbeing />} />
          <Route path="/Women-Empowerment" element={<WomenEmpowerment />} />
          <Route
            path="/Environment-Sustainability"
            element={<EnvironmentSustainability />}
          />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/Donate-Now" element={<Donate />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
};

export default App;
